import ItemModel from "../item-model"
import {EntityType} from "../../../gd/const/item"
import ItemsCollection from "../items-collection"
import GanttItemsCollection from "../../../gd-modules/gantt-chart/model/gantt-collection"
import GanttItem from "../../../gd-modules/gantt-chart/model/gantt-item-new"

// const debug = "itemsCollection_initTree"
const debug = false

export default function itemsCollection_initTree(itemCollection:ItemsCollection | GanttItemsCollection) {



    debug && console.log("init Tree root projectIds=", itemCollection.rootProjectIds)

    // reset(clear) tree children
    itemCollection.clearTree()

    if (!itemCollection.rootProjectIds || _.size(itemCollection.rootProjectIds)<1) {
        console.warn("#jdhjsad98234 it won't work we need roots!")
    }

    _.map(itemCollection.models, (item: any)=>{

        let parent  : ItemModel | GanttItem | null = null

        switch (item.type) {

            case EntityType.TASK:
                if (item.task.parentTaskId) {
                    parent = itemCollection.get('t-'+item.task.parentTaskId+'-'+item.projectItem.projectId)
                    if (parent) {
                        item.treeParent = parent
                    }
                }

                if (!parent) {
                    parent = itemCollection.getProject(item.parentProjectId)
                    if (parent) {
                        item.treeParent = parent
                    }
                }

                break

            case EntityType.PROJECT:

                // ok... treeRots & rootProjectIds
                // koroche eto case kogda proekt est' v projectIds no on sub folder of other rootProjectIds
                // patch itemCollection_structurePatch(itemCollection) - not in use...
                // i tut mi based on concept chto esli project tree to v collection ego NETU(!)

                if (itemCollection.rootProjectIds?.includes(item.project.id)) {
                    // console.orange(item.debugName, "is root")
                    // itemCollection is table root Item
                    // we DO not set tree parent

                    if (item.project.parentId) {
                        // console.orange("item.project.parentId not empty")
                        parent = itemCollection.getProject(item.project.parentId)

                        if (parent) {
                            item.treeParent = parent
                            // itemCollection.treeRoots.remove(listItem) - dont add to treeroots (!)
                        } else {
                            // Ok interesting case ... I guess we dont have it so make it root ?
                            // addon by vic for my tasks list
                            // console.log("no parent project found")
                            item.treeParent         = undefined
                            item.isRoot             = true
                            itemCollection.treeRoots.push(item) // add to tree roots !
                        }
                    } else {
                        // console.orange("item.project.parentId is empoty->add to roots")
                        item.treeParent         = undefined
                        item.isRoot             = true
                        itemCollection.treeRoots.push(item) // add to tree roots !
                    }

                } else {
                    if (item.project.parentId) {
                        parent = itemCollection.getProject(item.project.parentId)
                        if (parent) {
                            item.treeParent = parent
                        }
                    }
                }
                break

            case EntityType.EVENT:
                parent = itemCollection.getProject(item.event.projectId)
                if (parent) {
                    item.treeParent = parent
                } /*else {
                    // console.orange("item.event.parentId is empoty->add to roots")
                    item.treeParent         = undefined
                    item.isRoot             = true
                    itemCollection.treeRoots.push(item) // add to tree roots !
                }*/

                break
        }

        if (item.treeParent) {
            item.treeParent.treeChildren.push(item)
        }
    })



    // itemCollection.debugTreeRoots()

}